<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_re41"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('driverTeamReview_search_button')" @click="funcFilter">查询</el-button>
        <!-- <el-button @click="funcReport()">实际承运人上报</el-button> -->
        <el-button v-if="getLimit('driverTeamReview_batchOpenZy_button')" @click="openZhaoYou()">同步找油网</el-button>
        <el-button v-if="getLimit('driverTeamReview_export_button')" @click="funcExport">导出</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :cell-class-name="cellClassName"
      class="mytable-style"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          min-width="130"
          :formatter="({ cellValue }) => formatterField({ cellValue }, 'authStatus')"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          min-width="280"
          title="审核时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRanges"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="authMsg" title="驳回原因" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.authMsg" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="linkMan"
          title="车队名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="联系人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder="请输入身份证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="idCardDueDate"
          min-width="280"
          title="身份证到期日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange1"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isShare"
          title="是否清分"
          :formatter="({ cellValue }) => formatterField({ cellValue }, 'isShare')"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isShare" placeholder="请选择" clearable>
            <el-option
              v-for="item in isShareOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shareRatio"
          title="清分比率(%)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shareRatio"
            placeholder="请输入清分比率(%)"
            clearable
            @input="(value)=>formFormatter.ishundredInteger(value,oldValue,listQuery,'shareRatio')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="legalPerson"
          title="法人代表名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.legalPerson"
            placeholder="请输入法人代表名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="businessLicenseNumber"
          title="统一信用代码"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.businessLicenseNumber"
            placeholder="请输入统一信用代码"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="roadPermitNumber"
          title="道路运输经营许可证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadPermitNumber"
            placeholder="请输入道路运输经营许可证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 清分 -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="注册时间"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="280" fixed="right">
        <template slot-scope="scope">
          <el-tooltip v-if="getLimit('driverTeamReview_detail_button')" class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code,'detail')">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverTeamReview_audit_button') && ((scope.row.authStatusExt != 3 && groupLevel == 0) || (scope.row.authStatusExt != 3 && groupLevel != 0))"
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code,'review')">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverTeamReview_openZy_button') && scope.row.authStatusExt == 3 && !scope.row.cardNo"
            class="item"
            effect="dark"
            content="同步找油网"
            placement="top"
          >
            <vxe-button type="text" @click="openZhaoYou(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverTeamReview_lockCar_button') && scope.row.authStatusExt === 3 && scope.row.isFreezeExt != 1"
            effect="dark"
            content="冻结"
            placement="top"
          >
            <vxe-button type="text" @click="lockCar(scope.row)">
              <i class="el-icon-lock" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('driverTeamReview_unlockCar_button') && scope.row.authStatusExt === 3 && scope.row.isFreezeExt === 1"
            effect="dark"
            content="解除冻结"
            placement="top"
          >
            <vxe-button type="text" @click="unlockCar(scope.row)">
              <i class="el-icon-unlock" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 详情  详情-->
    <vxe-modal v-model="driverFlag" :title="modalTitle" width="1400" height="800" resize>
      <driverDetail ref="detailRef" :parent-data="parentData" @fatherMethods="fatherMethods" />
    </vxe-modal>
    <!-- 报文 -->
    <vxe-modal v-model="datagramFlag" title="报文详情" width="900" height="600" resize>
      <datagramDetail ref="datagramRef" :parent-data="parentData" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
  import driverDetail from "./components/driverDetail.vue";
  import datagramDetail from "./components/datagramDetail.vue";
  import {
    updateAuthStatus,
    getDriverTeamList,
    openZhaoYou,
    freezeDriver, unfreezeTeamDriver
  } from '@/api/driver'
export default {
  name: "CarrierReview",
  components: {
    driverDetail,
    datagramDetail
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/driver/exportTeamAuth",//导出接口
        name:'车队审核'
      },
      modalTitle: "详情",
      parentData: {
        isDetail: true,
        areaOptions:  this.$store.state.components.areaOptions,
      },
       exportableQuantity: localStorage.getItem('exportableQuantity'),
       exportableUrl:'ntocc-basic-api/driver/exportTeam',
      loading: false,
      tableData: [],
      driverFlag: false,
      datagramFlag: false,
      groupLevel:0,
      listQuery: {
        gmtCreatedRange: "",
        gmtCreatedRanges:"",
        gmtCreatedRange1:'',
        branchCodeExt:'',
        authStatus: "",
        authStatusExt: "",
        isFreezeExt:"",
        name: "",
        phone: "",
        driverType: 1,
        identificationNumber: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        balance: 0
      },
       // 审核状态
     authStatusOptions: [
      { label: "未审核", value: 0, color: "gray" },
          // { label: "审核中", value: 1, color: "#0000ff" },
      { label: "审核驳回", value: 2, color: "#ff0000" },
      { label: "审核通过", value: 3, color: "#00bd93" }
      ],
         // 是否清分
      isShareOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
    };
  },
   computed: {
    /**
     * 将“parentData”对象下的属性“model”返回为当前组件属性便于监控
    */
    model() {
      return this.parentData.model;
    }
  },
  watch: {
    model(val) {
     this.modalTitle = val === 'review'? '审核':'详情'
    }
  },
  created() {
      this.findList();
      this.groupLevel = JSON.parse(localStorage.getItem('dataBranch')).level;
  },
  mounted() {
  },
  methods: {
    findList() {
      // update by JiaYK start 2021/09/25 10:30 修复车队审核审核状态查询bug
      // if(this.$route.query.authStatusExt){
      //   this.listQuery.authStatusExt = Number(this.$route.query.authStatusExt)
      // }else{
      //   this.listQuery.authStatusExt = ''
      // }
      // update by JiaYK end 2021/09/25 10:30 修复车队审核审核状态查询bug
      this.listQuery.branchCodeExt = JSON.parse(localStorage.getItem('dataBranch')).code;
      this.loading = true;
      return new Promise(resolve => {
        getDriverTeamList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情
    funcEdit(code,prefix) {
      this.driverFlag = true;
      this.$refs.detailRef.getDriver(code);
      this.$set(this.parentData, "model", prefix);
    },
    // 报文详情
    funcSendDataGram(code) {
      this.datagramFlag = true;
      this.$refs.datagramRef.getDriver(code);
    },
    fatherMethods() {
      this.driverFlag = false;
      this.findList();
    },
    // 实际承运人上报
    funcReport(){
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message({ message: "请选择车队", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const codes = selectRecords.map(item => item.code).join(",");
        this.$confirm("确认上报监管平台吗？").then(_ => {
          const rLoading = this.openLoading();
          updateAuthStatus({ driverCodes: codes, sendType: 2 }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          }).finally(()=>{
            this.findList();
          });
        });
      }
    }, 
    //同步找油网
    openZhaoYou(row) {
      const selectRecords = row?[row]:this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        return this.$message({ message: "请选择车队", type: "warning" });
      } else if (selectRecords.length > 100) {
        return this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        let codes = []
        for(let item of selectRecords){
          if(item.authStatusExt!=3){
            return this.$message.warning("请选择审核通过的车队")
          }
          if(item.cardNo){
            return this.$message.warning("车队已同步")
          }
          codes.push(item.partyCode)
        }
        codes = codes.join(",");
        this.$confirm("确认同步找油网？")
        .then(_ => {
          const rLoading = this.openLoading();
          openZhaoYou({ partyCode: codes }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
      }
    },
     // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
      // 冻结
      lockCar(row) {
        this.$confirm("确认冻结吗？")
          .then(_ => {
            freezeDriver({ partyCode: row.partyCode }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      },
      // 解除冻结
      unlockCar(row) {
        this.$confirm("确认解除冻结吗？")
          .then(_ => {
            unfreezeTeamDriver({ partyCode: row.partyCode }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      },
      // 设置底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (column.property === "balance") {
              return this.sumObject.balance;
            }
            return "-";
          })
        ];
      },
      checCheckboxkMethod2 ({ row }) {
        return  row.isSendLoginkExt != 1
      },
	  cellClassName({ row, rowIndex, column, columnIndex }) {
	    const overDueType = row.overDueType||[];
	    //驾驶证
	    if (column.property === "driverLicenseDueDate") {
	      if (overDueType.indexOf('driver')>-1) {
	        return "col-red";
	      }
	    }
	    //形驶证
	    if (column.property === "vehicleLicenseDueDate") {
	      if (overDueType.indexOf('vehicle')>-1) {
	        return "col-red";
	      }
	    }
	    //从业资格证
	    if (column.property === "workLicenseDueDate") {
	      if (overDueType.indexOf('work')>-1) {
	        return "col-red";
	      }
	    }
	    //从业资格证
	    if (column.property === "roadTransportCertificateDate") {
	      if (overDueType.indexOf('road')>-1) {
	        return "col-red";
	      }
	    }
	    //身份证
	    if (column.property === "idCardDueDate") {
	      if (overDueType.indexOf('idCard')>-1) {
	        return "col-red";
	      }
	    }
	  },
    }
  };
</script>
<style scoped>
	.mytable-style .vxe-body--column.col-red {
	  background-color: red;
	  color: #fff;
	}
</style>
